import {
  CreateSupporterError,
  CreateSupporterRequestParams,
  ListSupportersRequestParams,
  SantizedSupporter,
} from 'models/Supporter'

import { api } from '../api'
import toAPIv2QueryString from 'utils/functions/toAPIv2QueryString'

export const supportersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createOrganizationSupporter: builder.mutation<
      SantizedSupporter | CreateSupporterError,
      { orgId: string; supporter: CreateSupporterRequestParams }
    >({
      query: ({ orgId, supporter }) => ({
        url: `/organizations/${orgId}/supporters`,
        method: 'POST',
        body: supporter,
      }),
    }),
    listOrganizationSupporters: builder.query<
      SantizedSupporter[],
      { orgId: string; params: ListSupportersRequestParams }
    >({
      query: ({ orgId, params }) => ({
        url: `/organizations/${orgId}/supporters?${toAPIv2QueryString(params)}`,
      }),
    }),
  }),
})

export const {
  useCreateOrganizationSupporterMutation,
  endpoints: { listOrganizationSupporters, createOrganizationSupporter },
} = supportersApi
